<div class="card">
    <div class="card-body">
        <div class="row mb-2">
            <div class="col-6">
                <h5 class="mt-0 mb-2">
                    Referencias
                </h5>
            </div>
            <div class="col-6">
                <div class="text-end">
                    <button type="button" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal"
                        (click)="add()"
                        data-bs-target="#modalReference">
                        <i class="fa-regular fa-square-plus"></i>
                        Nuevo
                    </button>
                </div>
            </div>
        </div>
        <div class="table-responsive mb-2">
            <table class="table table-hover table-theme">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Empresa</th>
                        <th>Posición</th>
                        <th>Teléfono</th>
                        <th>Correo electrónico</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    @for (item of references(); let index = $index; track $index) {
                    <tr>
                        <td class="text-left">{{item.firstName}} {{item.lastName}}</td>
                        <td class="text-left">{{item.company}}</td>
                        <td class="text-left">{{item.position}}</td>
                        <td class="text-left">{{item.phone | mask: '(000)-000-0000'}}</td>
                        <td class="text-left">{{item.email}}</td>
                        <td class="text-center">
                            <button (click)="editResumeReference(item, index)" type="button"
                                class="btn btn-outline-success me-2" data-bs-toggle="modal"
                                data-bs-target="#modalReference">
                                <i class="fa-solid fa-pen-to-square"></i>
                            </button>
                            <button (click)="deleteResumeReference(item, index)" type="button"
                                class="btn btn-outline-danger">
                                <i class="fa-regular fa-trash-can"></i>
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>

<app-modal-reference 
[resumeId]="resumeId()"
(onResumeReference)="handlerResumeReference($event)"/>